import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';

import MultiSelectDropdown from '../../../../components/MultiSelectDropdown';
import {
  selectCompanyUsersFromEmails,
  selectRecordRecipients,
  updateInsuredRecipients
} from '../../../../redux/modules/emails';
import { arrayFilterAndMap, unique } from '../../../../utils/arrayUtil';

const RecipientsCell = ({ row: { original: { id: recordId, insured, insurancePolicies, job } } }) => {
  const dispatch = useDispatch();
  const recipients = useSelector(selectRecordRecipients(recordId));
  const [customRecipients, setCustomRecipients] = useState([]);
  const companyUsers = useSelector(selectCompanyUsersFromEmails);

  const brokerEmails = useMemo(() => unique(arrayFilterAndMap(
    insurancePolicies || [],
    policy => (!!policy.owner
      && policy.owner?.email?.length
      && !['implementation@pinsadvantage.com', 'jumpstart@pinsadvantage.com'].includes(policy.owner?.email)
      && !companyUsers?.map(user => user.userId)?.includes(policy.owner.id)
    ),
    policy => ({ id: policy.owner.id, email: policy.owner.email, type: 'user', job_id: job.id })
  ), item => item.email), [companyUsers]);

  if (insured.email) {
    brokerEmails.unshift({
      email: insured.email,
      id: insured.id,
      type: 'insured',
      job_id: job.id
    });
  }

  const onRecipientChange = changedRecipients => {
    const newCustomRecipients = changedRecipients.map(r => ({
      ...r,
      id: r.id || r.email,
      type: r.type || 'custom',
      job_id: job.id,
      record_id: recordId
    }));

    dispatch(updateInsuredRecipients(insured.id, newCustomRecipients, job.id, recordId));
    setCustomRecipients(newCustomRecipients);
  };

  const data = useMemo(() => unique([
    ...customRecipients,
    ...brokerEmails,
    ...recipients
  ], item => `${item.email}-${item.job_id}`), [customRecipients, brokerEmails, recipients]);

  return (
    <Box maxW="600px" minW="400px">
      <MultiSelectDropdown
        allowCustomValues
        customValuePlaceholder="Add Custom Recipient"
        customValueValidation="emailAddress"
        data={data}
        idKey="email"
        labelKey="email"
        placeholder="Suggested Recipients"
        values={recipients}
        onChange={onRecipientChange}
      />
    </Box>
  );
};

export default RecipientsCell;
